import { GameRoomState } from "@presidents/game-engine";
import React, { useContext, useEffect, useState } from "react";
import { GameRoomController } from "../game/GameRoom";
import { useSocket } from "./SocketContext";
import { useUser } from "./UserContext";

const GameRoomCtx = React.createContext<{
  gameRoom: GameRoomController | null;
}>({
  gameRoom: null
});

export const GameRoomProvider: React.FC<{
  roomId: string;
  children: React.ReactNode;
}> = ({ roomId, children }) => {
  const [state, setState] = useState<GameRoomState | null>(null);
  const [gameRoom, setClient] = useState<GameRoomController | null>(null);
  const user = useUser();
  const socket = useSocket();
  useEffect(() => {
    if (user && socket) {
      const instance = new GameRoomController(roomId, user!, socket!, state);
      const unsub = instance.listen((nextState) => {
        setState(nextState);
      });
      setClient(instance);
      return () => {
        unsub();
        instance.destroy();
      };
    }
  }, [socket]);

  const ctx: React.ContextType<typeof GameRoomCtx> = {
    gameRoom
  };

  return <GameRoomCtx.Provider value={ctx}>{children}</GameRoomCtx.Provider>;
};

export const useGameRoom = () => useContext(GameRoomCtx);
